import { 
    IMutations,
    IMutationsTechnicalReportPayload
} from './mutations.types'
import { ITechnicalReport, INotification, ITechnicalReportData } from '@/entities'
import { AppConstants as _app } from '@/shared/app.constants'

export const mutations: IMutations = {
    
    /** refresh the state with application header info */
    setTechnicalReport(state: ITechnicalReportData, payload: IMutationsTechnicalReportPayload): void {
        if(!payload.report.WorkflowInfo) {
            payload.report.WorkflowInfo = state.selectedReport.WorkflowInfo
        }
        state.selectedReport = payload.report;
    },

    setGrantTemplate(state: ITechnicalReportData, payload: any) {
        state.grantTemplate = payload.template[state.language].properties;
    },

    setTechnicalReportTemplate(state: ITechnicalReportData, payload: any) {
        state.techReportTemplate = payload;
    },

    setGrant(state: ITechnicalReportData, payload: any) {
        state.grantInfo = payload.meta;
        state.grantData = payload.data;
        state.impact = payload.impact;
        state.finalReport = payload.finalReport;
        state.isStartingPeriod = payload.isStartingPeriod;
        state.documentTags = payload.docCategories.tags;
        state.documentCategories = payload.docCategories.categories;
    },

    refreshModel(state: ITechnicalReportData, payload: any) {
        state.grantData = payload.report.data;
        state.finalReport = payload.report.finalReportData || {};
        state.impact = payload.report.impactReport || {};
    },

    setReportData(state: ITechnicalReportData, payload: any) {
        state.grantData = payload.report.data;
        state.impact = payload.report.impactReport || {};
    },

    updateSelectedKey(state: ITechnicalReportData, payload: any) {
        state.selectedKey = payload;
    }
}